module.exports = __webpack_public_path__ + "img/sec6mob.64dddf63.png";